export const PAGE_SIZE = 50

// Converts array of objects to object
export const arrayToObject = <T>(arr: (T & { id: string })[]) => {
  const obj: Record<string, T> = arr.reduce((prev, curr) => {
    prev[curr.id] = curr
    return prev
  }, {})

  return obj
}
